import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
export function HeaderBanner() {
  return <div className="w-full py-12 md:py-16 relative overflow-hidden" style={{
    backgroundColor: '#1e3d2f'
  }} data-id="element-2523">
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#c8a84b 1px, transparent 1px)',
      backgroundSize: '24px 24px'
    }} data-id="element-2524" />
      <div className="max-w-4xl mx-auto px-4 md:px-8 relative z-10" data-id="element-2525">
        <div className="flex items-center gap-2 mb-4" data-id="element-2526">
          <Link to="/" className="text-xs font-bold uppercase tracking-widest transition-colors hover:text-white" style={{
          color: '#a0c8b0',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-2527">
            Home
          </Link>
          <ChevronRightIcon size={12} style={{
          color: '#a0c8b0'
        }} data-id="element-2528" />
          <span className="text-xs font-bold uppercase tracking-widest" style={{
          color: '#a0c8b0',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-2529">
            Members
          </span>
          <ChevronRightIcon size={12} style={{
          color: '#a0c8b0'
        }} data-id="element-2530" />
          <span className="text-xs font-bold uppercase tracking-widest" style={{
          color: '#c8a84b',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-2531">
            Policies
          </span>
        </div>
        <h1 className="text-4xl md:text-5xl font-bold uppercase" style={{
        fontFamily: 'Oswald, sans-serif',
        color: '#ffffff'
      }} data-id="element-2532">
          Club Policies
        </h1>
        <p className="mt-3 text-base" style={{
        color: '#a0c8b0',
        fontFamily: 'Inter, sans-serif'
      }} data-id="element-2533">
          Official policies of the Fenton Lakes Sportsman's Club
        </p>
        <div className="w-16 h-1 mt-6 rounded-full" style={{
        backgroundColor: '#c8a84b'
      }} data-id="element-2534" />
      </div>
    </div>;
}